import store from '../store/store';
import router from '../router/router';
import axios from 'axios';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
class Http {
	constructor() {
		this.http = axios.create({
			baseURL: process.env.VUE_APP_BASE_URL,
		});

		this.http.interceptors.response.use(
			(response) => {
				return response;
			},
			async (error) => {
				if (error.response.status === 401) {
					const token = localStorage.getItem(`token`);
					
					if (!token) {
						if (window.location.pathname == '/login') return;
						return router.push('/login');
					}

					await store.dispatch('login/REFRESH_TOKEN_REQUEST');

					return window.location.reload();
				}
				
				const refreshTokenInvalidMessage = 'Token não é valido';

				if (error.response.data.message === refreshTokenInvalidMessage) {
					return router.push('/login');
				}

				return Promise.reject(error);
			},
		);
	}
}

export default class SingletonHttp {
	constructor() {
		throw new Error('Use SingletonHttp.getInstance()');
	}

	static getInstance() {
		if (!SingletonHttp.instance) {
			SingletonHttp.instance = new Http();

			SingletonHttp.instance.http.defaults.headers.common['Accept-Language'] = 'pt-br';

			if (localStorage.getItem('token')) {
				SingletonHttp.instance.http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
					'token',
				)}`;
			}
		}

		return SingletonHttp.instance;
	}
}
